import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { RiFireLine, RiPinDistanceFill } from "react-icons/ri";
import footprint from "../../../../assets/footprint-fill.png";

type Series = {
  name: string;
  data: number[];
};

interface AgeGroupBiasedChartProps {
  selectedMetric: "steps" | "distance" | "caloriesburned";
  categories: string[];
  series: Series[];
  onMetricChange: (metric: "steps" | "distance" | "caloriesburned") => void;
}

const AgeGroupBiasedChart: React.FC<AgeGroupBiasedChartProps> = ({
  selectedMetric,
  categories,
  series,
  onMetricChange,
}) => {
  const handleToggle = (metric: "steps" | "distance" | "caloriesburned") => {
    onMetricChange(metric);
  };

  const options: ApexOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
    },
    xaxis: {
      categories,
    },
    yaxis: {
      title: {
        text: selectedMetric,
      },
    },
    stroke: {
      curve: "smooth",
    },
    markers: {
      size: 3,
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    colors: ["#379793", "#2C5364", "#53E3DD", "#081919"],
  };

  return (
    <div className="age-group-chart-container">
      <div className="MetricToggleContainer">
        <div className="Metric-Icons">
          <button
            className={`GraphIcon ${selectedMetric === "steps" ? "active" : ""}`}
            onClick={() => handleToggle("steps")}
          >
            <img src={footprint} alt="Steps" />
          </button>
          <button
            className={`GraphIcon ${selectedMetric === "distance" ? "active" : ""}`}
            onClick={() => handleToggle("distance")}
          >
            <RiPinDistanceFill />
          </button>
          <button
            className={`GraphIcon ${selectedMetric === "caloriesburned" ? "active" : ""}`}
            onClick={() => handleToggle("caloriesburned")}
          >
            <RiFireLine />
          </button>
        </div>
      </div>
      <ReactApexChart
        type="line"
        options={options}
        series={series}
        height={300}
      />
    </div>
  );
};

export default AgeGroupBiasedChart;
